<template lang="pug">
  .container
    .menu_block
      .item(v-for="item in resultPermissions" @click="redirectTo(item)")
        img(:src="item.icon")
        .text {{item.title}}
</template>

<script>
import store from '../../../store'

export default {
  props: ['list'],
  data () {
    return {
      permissions: store.state.user.user.frontend_sections
    }
  },
  computed: {
    resultPermissions () {
      return this.list.filter(
        item => this.permissionMap.indexOf(item.permission) !== -1
      )
    },
    permissionMap () {
      let permissionMap = []
      this.permissions.forEach(permission => {
        permissionMap.push(permission)
      })
      return permissionMap
    }
  },
  methods: {
    redirectTo (item) {
      return this.$router.push({ name: item.state })
    }
  }
}
</script>

<style lang="sass" scoped>
.container
  display: flex
  justify-content: center
  padding-top: 100px
.menu_block
  width: 1200px
  display: grid
  grid-template-columns: 1fr 1fr 1fr
  grid-column-gap: 100px
.item
  margin-bottom: 100px
  cursor: pointer
  text-align: center
.item:hover
  text-decoration: underline
  transition: all, 0.3s
.text
  margin-top: 8px
  font-size: 22px
img
  width: 130px
@media screen and (max-width: 640px)
  .container
    justify-content: start
    padding-top: 100px
  .menu_block
    display: block
    width: auto
  .item
    display: grid
    grid-template-columns: 115px auto
    text-align: left
    margin-bottom: 20px
    margin-left: 20px
  img
    width: 100px
  .text
    margin-top: 47px
    font-size: 20px
</style>
